import React, { useEffect, useState } from "react";
import { Badge, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import axios from "../../../../../config/axios";
import InfoModal from "src/components/Modal/Info";

const StripeInfoModal = ({ show, handleClose }) => {
  const [stripeAccount, setStripeAccount] = useState();
  const [onlineReservationSetting, setOnlineReservationSetting] = useState({});
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation("dashboard");

  const loadStripeAccount = () => {
    setLoading(true);

    return Promise.all([
      axios.get("api/v1/online_reservation_setting.json"),
      axios
        .get("api/v1/stripe_account.json")
        .catch(() => ({ data: undefined })),
    ])
      .then(([settingsResponse, stripeAccountResponse]) => {
        setOnlineReservationSetting(settingsResponse.data);
        setStripeAccount(stripeAccountResponse.data);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const openStripeWindow = (request) => {
    const stripeWindow = window.open("", "_blank");
    if (!stripeWindow) {
      alert("Popup blocked");
      return;
    }

    stripeWindow.document.documentElement.innerHTML =
      "<head><title>Stripe</title></head><body>Loading Stripe...</body>";

    request().then((response) => {
      stripeWindow.location.href = response.data.account_link_url;
    });
  };

  function handleCompleteRegistration() {
    openStripeWindow(() =>
      axios.get("api/v1/stripe_account/create_account_link.json")
    );
  }

  function handleCreateStripeAccount() {
    openStripeWindow(() => axios.post("api/v1/stripe_account.json"));
  }

  useEffect(() => {
    if (show) {
      loadStripeAccount();
    }
  }, [show]);

  const renderStripeConditions = () => {
    if (!stripeAccount?.details_submitted) {
      return;
    }

    return (
      <div className={"mt-3"}>
        <strong>{t("settings.online_reservation.stripe.conditions")}:</strong>
        <div>
          {t("settings.online_reservation.stripe.commission_fee")}:{" "}
          {onlineReservationSetting.stripe_commission_percent}%
        </div>
        <div>
          {t("settings.online_reservation.stripe.minimum_fee")}:{" "}
          {onlineReservationSetting.stripe_commission_min_cents} Cent
        </div>
        <div className={"mt-2"}>
          <a
            href="https://stripe.com/de/pricing#standard-pricing"
            rel="noreferrer"
            target="_blank"
          >
            Stripe Preise
          </a>
        </div>
      </div>
    );
  };

  return (
    <InfoModal
      show={show}
      handleClose={handleClose}
      title={"Stripe"}
      loading={loading}
    >
      {stripeAccount ? (
        <>
          <span>
            <strong>
              {t("settings.online_reservation.stripe.stripe_account_id")}:
            </strong>{" "}
            {stripeAccount.stripe_account_id}
          </span>
          <br />
          <span>
            <strong>
              {t("settings.online_reservation.stripe.charges_enabled")}:
            </strong>{" "}
            {stripeAccount.charges_enabled
              ? t("common:general.yes")
              : t("common:general.no")}
          </span>
          <br />
          <span>
            <strong>
              {t("settings.online_reservation.stripe.transfers_enabled")}:
            </strong>{" "}
            {stripeAccount.transfers_enabled
              ? t("common:general.yes")
              : t("common:general.no")}
          </span>
          <br />
          <span>
            <strong>
              {t("settings.online_reservation.stripe.onboarding_completed")}:
            </strong>
            <Badge
              pill
              bg={stripeAccount.details_submitted ? "success" : "warning"}
              text={"light"}
              className="ml-2"
            >
              {stripeAccount.details_submitted
                ? t("common:general.yes")
                : t("common:general.no")}
            </Badge>
          </span>
          {renderStripeConditions()}
          {!stripeAccount.details_submitted && (
            <Button
              className={"mt-2"}
              size={"sm"}
              onClick={handleCompleteRegistration}
              target={"_blank"}
            >
              Registrierung abschließen
            </Button>
          )}
        </>
      ) : (
        <Button
          className={"mb-2"}
          size={"sm"}
          target={"_blank"}
          onClick={handleCreateStripeAccount}
        >
          Stripe Account erstellen
        </Button>
      )}
    </InfoModal>
  );
};

export default StripeInfoModal;
